/** Fenêtre de numéros de page pour mobile (évite d'afficher 60+ boutons). */
export function getPaginationWindow(currentPage, totalPages, maxVisible = 5) {
  if (totalPages <= 0) return [];
  if (totalPages <= maxVisible) {
    return Array.from({ length: totalPages }, (_, i) => i);
  }
  const half = Math.floor(maxVisible / 2);
  let start = Math.max(0, currentPage - half);
  let end = start + maxVisible - 1;
  if (end >= totalPages) {
    end = totalPages - 1;
    start = Math.max(0, end - maxVisible + 1);
  }
  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
}
